'use client';

import { Badge } from '@mage-ui/components';
import { cx } from '@mage-ui/styled-system/css';
import {
	badge,
	languageCourseDisplay,
	shopCard,
	title,
} from '@mage-ui/styled-system/recipes';
import { useContext } from 'react';
import { StaticTextContext } from '@/components/context/StaticTextProvider';
import { ShopCardFooter } from './ShopCardFooter';
import { ShopCardList } from './ShopCardList';
import { ShopCardPlaceholder } from './ShopCardPlaceholder';

export const ShopCard = ({ data, className }) => {
	const { st } = useContext(StaticTextContext);
	return (
		<div
			className={cx(
				className?.root ?? shopCard().root,
				data?.enabled === false ?? shopCard().disabled,
			)}
			id={data?.id}
		>
			<div className={shopCard().topContent}>
				<Badge classNames={{ root: badge({ status: 'neutral', size: 's' }) }}>
					{/* TEMP - 19032026 */}
					{!data?.iso
						? st('cart.category_raffle')
						: st('cart.category_dossier')}
				</Badge>
			</div>
			<div className={shopCard().contentWrapper}>
				{data?.iso ? (
					<div
						className={cx(languageCourseDisplay().root, shopCard().metaWrapper)}
					>
						<abbr
							title={data?.language}
							className={cx(
								title({ size: '2', weight: 'bold' }),
								languageCourseDisplay().title,
								shopCard().title,
							)}
						>
							{data?.iso}
						</abbr>
						{data?.language && (
							<Badge
								aria-hidden='true'
								className={languageCourseDisplay().label}
							>
								{data?.language}
							</Badge>
						)}
					</div>
				) : (
					<div
						className={cx(languageCourseDisplay().root, shopCard().metaWrapper)}
					>
						<ShopCardPlaceholder texts={{ a11yText: data?.name }} />
					</div>
				)}
				<ShopCardList
					className={shopCard().infoWrapper}
					data={data?.infoData}
				/>
			</div>
			<ShopCardFooter data={data} />
		</div>
	);
};
